/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_DurationInputs */

const en_video_duration = /** @type {(inputs: Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video Duration`)
};

const fr_video_duration = /** @type {(inputs: Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée de la vidéo`)
};

const de_video_duration = /** @type {(inputs: Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videodauer`)
};

const it_video_duration = /** @type {(inputs: Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata del video`)
};

const ru_video_duration = /** @type {(inputs: Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продолжительность видео`)
};

const es_video_duration = /** @type {(inputs: Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración del video`)
};

const zh_cn2_video_duration = /** @type {(inputs: Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频时长`)
};

const ja_video_duration = /** @type {(inputs: Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画の長さ`)
};

const hi_video_duration = /** @type {(inputs: Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो की अवधि`)
};

const pt_pt2_video_duration = /** @type {(inputs: Video_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração do vídeo`)
};

/**
* | output |
* | --- |
* | "Video Duration" |
*
* @param {Video_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_duration = /** @type {((inputs?: Video_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_duration(inputs)
	if (locale === "de") return de_video_duration(inputs)
	if (locale === "it") return it_video_duration(inputs)
	if (locale === "ru") return ru_video_duration(inputs)
	if (locale === "es") return es_video_duration(inputs)
	if (locale === "zh-CN") return zh_cn2_video_duration(inputs)
	if (locale === "ja") return ja_video_duration(inputs)
	if (locale === "hi") return hi_video_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_video_duration(inputs)
	return en_video_duration(inputs)
});